import React from 'react';
import { motion } from 'framer-motion'; // Ensure framer-motion is installed
import { 
  MoreVertical, ThumbsUp, MessageCircle, 
  Share2, CheckCircle2, Globe, Plus, MessageCircleMore
} from 'lucide-react';
import styles from './SocialSamples.module.css';

const SocialSamples = () => {
  // --- REPLACEMENT: YOUR WHATSAPP DETAILS ---
  const phoneNumber = "917533928185"; // Replace with your actual number (with country code)
  const websiteLink = window.location.href;
  const waMessage = encodeURIComponent(`Hello Ananta Team, I'm interested in your AI News Anchors. Please send me more demo videos. \n\nRef: ${websiteLink}`);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${waMessage}`;

  const youtubeSamples = [
    { id: "m8rweS3yu6s", title: "AI News: India's Tech Revolution 2026 | Exclusive Report", views: "1.2M views", date: "2 days ago", channel: "Ananta News" },
    { id: "IpSz6alBg-o", title: "Global Market Updates | Morning Business Bulletin with AI Anchor", views: "850K views", date: "5 hours ago", channel: "Ananta Business" },
    { id: "RbypO_BQ_xE", title: "New AI Anchor Models Released for Digital Media Production", views: "2.4M views", date: "1 week ago", channel: "Ananta Tech" },
    { id: "ysLDwd4Wy1U", title: "Digital Newsroom Transformation: The Future of Journalism", views: "920K views", date: "3 days ago", channel: "Ananta News" },
  ];

  const getFbEmbedUrl = (url) => `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0&width=500`;

  const facebookSamples = [
    { id: 1, name: "Ananta Digital", time: "Sponsored", desc: "Start your own 24/7 News Channel with AI anchors today! No studio required. 🚀", videoUrl: getFbEmbedUrl("https://www.facebook.com/reel/26309452868671361") },
    { id: 2, name: "Daily News Feed", time: "12h ago", desc: "How AI is changing the face of journalism in India. High-quality production. #TechNews", videoUrl: getFbEmbedUrl("https://www.facebook.com/reel/1718211799561408") },
    { id: 3, name: "Media Pulse", time: "2d ago", desc: "The future of newsrooms is virtual. See our latest AI models in action.", videoUrl: getFbEmbedUrl("https://www.facebook.com/reel/916566987970116") },
  ];

  return (
    <section className={styles.sectionContainer}>
      <div className={styles.wrapper}>
        <h2 className={styles.sectionTitle}>Sample <span className={styles.accent}>AI Broadcasts</span></h2>

        {/* --- YOUTUBE GROUP --- */}
        <div className={styles.platformGroup}>
          <div className={styles.platformHeader}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/e/ef/Youtube_logo.png" alt="YT" className={styles.logoYT} />
            <span className={styles.platformName}>YouTube Format</span>
          </div>
          <div className={styles.carousel}>
            {youtubeSamples.map((vid) => (
              <div key={vid.id} className={styles.standardCard}>
                <div className={styles.videoBox}>
                  <iframe 
                    src={`https://www.youtube.com/embed/${vid.id}?modestbranding=1&rel=0`}
                    title={vid.title}
                    allowFullScreen
                  ></iframe>
                </div>
                <div className={styles.ytInfo}>
                  <div className={styles.avatarYT}>A</div>
                  <div className={styles.ytText}>
                    <h4 className={styles.ytTitle}>{vid.title}</h4>
                    <div className={styles.ytChannelRow}>
                        <span className={styles.ytChannelName}>{vid.channel}</span>
                        <CheckCircle2 size={12} fill="#94a3b8" color="#020617" />
                    </div>
                    <p className={styles.ytMeta}>{vid.views} • {vid.date}</p>
                  </div>
                  <MoreVertical size={18} color="#94a3b8" className={styles.moreIcon} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* --- FACEBOOK GROUP --- */}
        <div className={styles.platformGroup}>
          <div className={styles.platformHeader}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_(2019).png" alt="FB" className={styles.logoFB} />
            <span className={styles.platformName}>Facebook Watch</span>
          </div>
          <div className={styles.carousel}>
            {facebookSamples.map((post) => (
              <div key={post.id} className={styles.standardCard}>
                <div className={styles.fbInnerCard}>
                  <div className={styles.fbHeader}>
                    <div className={styles.avatarFB}>A</div>
                    <div className={styles.fbUser}>
                      <h5>{post.name}</h5>
                      <p>{post.time} • <Globe size={10} /></p>
                    </div>
                    <div className={styles.fbFollow}><Plus size={14} /> Follow</div>
                  </div>
                  <p className={styles.fbText}>{post.desc}</p>
                  <div className={styles.videoBox}>
                    <iframe src={post.videoUrl} className={styles.fbIframe} scrolling="no" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                  </div>
                  <div className={styles.fbActions}>
                    <div className={styles.fbBtn}><ThumbsUp size={16} /> Like</div>
                    <div className={styles.fbBtn}><MessageCircle size={16} /> Comment</div>
                    <div className={styles.fbBtn}><Share2 size={16} /> Share</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* --- NEW ANIMATED REQUEST BUTTON --- */}
        <div className={styles.demoCtaWrapper}>
            <p className={styles.ctaPrompt}>Click the button below for more demo videos</p>
            <motion.a 
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.requestBtn}
                initial={{ scale: 1 }}
                animate={{ 
                    scale: [1, 1.05, 1],
                    boxShadow: [
                        "0px 0px 0px rgba(37, 211, 102, 0)", 
                        "0px 0px 20px rgba(37, 211, 102, 0.4)", 
                        "0px 0px 0px rgba(37, 211, 102, 0)"
                    ]
                }}
                transition={{ 
                    duration: 2, 
                    repeat: Infinity, 
                    ease: "easeInOut" 
                }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
            >
                <MessageCircleMore size={22} />
                Request More Demo
                <div className={styles.shimmer}></div>
            </motion.a>
        </div>
      </div>
    </section>
  );
};

export default SocialSamples;